import React from 'react';
import { withStyles, Grid, Typography, } from '@material-ui/core';
import MDivider from '../../view/MDivider';

class MBasketTableHeader extends React.Component {

    render() {
        const { title, subtitle } = this.props;
        return (
            <Grid container direction='row' alignItems='center' justifyContent='space-between'>
                <Grid container direction='row' alignItems='center' justifyContent='flex-start' style={{ flex: 1, maxWidth: '50%' }}>
                    <MDivider width={3} height={9} backgroundColor='#FC2E34' borderRadius={1.5} marginH={8} ></MDivider>
                    <Typography style={{ color: '#0D0D0D', fontSize: 12 }}>{title}</Typography>
                </Grid>
                <Grid container direction='row' alignItems='center' justifyContent='flex-end' style={{ flex: 1 }}>
                    <Typography style={{ color: '#0D0D0D', fontSize: 12 }}>{subtitle}</Typography>
                    <MDivider width={3} height={9} backgroundColor='#368CF4' borderRadius={1.5} marginH={8}></MDivider>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles((theme) => ({


}))(MBasketTableHeader);